let csrfToken = '';
export const setCsrfToken = (value) => { csrfToken = value || ''; };

export async function fetchWithAuth(url, options = {}) {
  const method = (options.method || 'GET').toUpperCase();
  const headers = new Headers(options.headers || {});
  if (!['GET', 'HEAD', 'OPTIONS'].includes(method)) headers.set('X-CSRF-Token', csrfToken);
  const response = await fetch(url, { ...options, headers, credentials: 'same-origin' });
  if (response.status === 401) {
    window.dispatchEvent(new Event('auth-expired'));
    throw new Error('Please sign in again.');
  }
  if (response.status === 403) {
    window.dispatchEvent(new Event('auth-forbidden'));
    throw new Error('You do not have access to this page or action.');
  }
  return response;
}
